import clsx from "clsx";
import React from "react";

const AchievementCard = ({
  title,
  count,
  unit,
  borderClasses,
  customValueClasses,
  icon,
}) => {
  return (
    <div className={`d-flex w-100 align-items-stretch justify-content-center`}>
      <div
        className={`tw-bg-white tw-flex tw-flex-col tw-justify-center tw-shadow-md tw-w-full tw-px-2 tw-py-4 tw-border-l-4 ${borderClasses}`}
      >
        {title && (
          <h4 className="card-title text-center text-capitalize tw-text-[17px] d-flex tw-flex-col justify-content-center align-items-center gap-1">
            {icon && <img src={icon} alt="identicator" width="24px"></img>}
            <span>{title}</span>
          </h4>
        )}

        <div className="">
          <div className="d-flex justify-content-between flex-column align-items-center w-100 tw-gap-0">
            {count !== undefined && (
              <div
                className={clsx(
                  customValueClasses,
                  "tw-text-base tw-text-center tw-text-primary"
                )}
              >
                {count}
              </div>
            )}

            {unit && <div className="text-muted tw-text-xs">{unit}</div>}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AchievementCard;
